import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconAddSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7H9.00045V4C9.00045 3.44772 8.55274 3 8.00045 3C7.44817 3 7.00045 3.44772 7.00045 4L7.00045 7H4C3.44772 7 3 7.44772 3 8C3 8.55228 3.44772 9 4 9H7.00045V12C7.00045 12.5523 7.44817 13 8.00045 13C8.55274 13 9.00045 12.5523 9.00045 12V9H12Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
